import { z } from '@/libs/zod';

import { promotionOfferSchema } from './Raffle';

const utmSchema = z.object({
  name: z.string().optional(),
  utm_term: z.string().optional(),
  utm_source: z.string().optional(),
  utm_content: z.string().optional(),
  utm_medium: z.string().optional(),
  utm_campaign: z.string().optional(),
  raffleId: z.string().optional(),
});

export const purchaseRequestSchema = z.object({
  raffleId: z.string(),
  ticketsAmount: z.number(),
  customerId: z.string(),
  isFromBalance: z.boolean(),
  purchaseWithPromotion: z.boolean(),
  vmb: z.string(),
  vmb_id: z.string(),
  fbp: z.string(),
  fbc: z.string(),
  totalValue: z.number().optional(),
  ticketPrice: z.number().optional(),
  name: z.string().optional(),
  socialName: z.string().optional(),
  soldById: z.string().optional(),
  linkAffiliate: z.string().optional(),
  fcmToken: z.string().optional(),
  leadId: z.string().optional(),
  estrelaLeadId: z.string().optional(),
  vivoLeadId: z.string().optional(),
  claroLeadId: z.string().optional(),
  timLeadId: z.string().optional(),
  promotionTicketsAmount: z.number().optional(),
  promotionPercentage: z.number().optional(),
  isPromotionAvailable: z.boolean().optional(),
  acceptedOffers: z
    .array(z.object({ offerId: z.string(), ticketsAmount: z.number() }))
    .optional(),
  promotionOffers: z.array(promotionOfferSchema).optional(),
  promotionOffersResolved: z.boolean().optional(),
  isPostGameUpsell: z.boolean().optional(),
  utm: utmSchema.optional(),
  upsell: z
    .object({
      isUpsell: z.boolean().optional(),
      type: z.string().optional(),
      step: z.string().optional(),
      optionSelected: z.union([z.number(), z.string()]).optional(),
      originalQuantity: z.number().optional(),
      newQuantity: z.number().optional(),
    })
    .optional(),
});

export const purchaseResponseSchema = z.object({
  qrCode: z.string(),
  cartId: z.string(),
});

export type PurchaseRequest = z.infer<typeof purchaseRequestSchema>;
export type PurchaseResponse = z.infer<typeof purchaseResponseSchema>;
